var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleNewsThumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5383EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1175 13.9303V17.3742C16.1175 17.3742 19.3698 17.3697 20.6941 17.3697C19.977 19.6022 18.8619 20.818 16.1175 20.818C13.3402 20.818 11.1725 18.5052 11.1725 15.6522C11.1725 12.7993 13.3402 10.4865 16.1175 10.4865C17.5859 10.4865 18.5343 11.0166 19.4042 11.7556C20.1005 11.0403 20.0423 10.9384 21.8139 9.21984C20.31 7.81373 18.3113 6.95654 16.1175 6.95654C11.4423 6.95654 7.65234 10.8497 7.65234 15.6522C7.65234 20.4546 11.4423 24.3478 16.1175 24.3478C23.1057 24.3478 24.8137 18.0973 24.2474 13.9303H16.1175L16.1175 13.9303Z",
    fill: "white"
  })));
}

export default SvgGoogleNewsThumb;